import React, { useState, useEffect } from "react";
import "./SelectQuantity.css";
import DropdownContainer from "./DropdownContainer";

const SelectQuantity = (props) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [digitalProofCharge, setDigitalProofCharge] = useState(0);
  const handleOpenDropdown = () => {
    setDropdownActive(true);
  };

  const handleCloseDropdown = () => {
    setDropdownActive(false);
  };

  useEffect(() => {
    if (props.price && props.quantity) {
      const totalPrice = (parseFloat(props.price) * props.quantity).toFixed(2);
      setTotalPrice(totalPrice);
      let digitalProofCharge = 0;
      if (props.hasPhotos) {
        if (props.selectedProofOption === "digitalproof") {
          digitalProofCharge = 15;
        }
      } else if (props.hasArt) {
        digitalProofCharge = 50;
      } else if (props.selectedProofOption === "digitalproof") {
        digitalProofCharge = 15;
      }
      setDigitalProofCharge(digitalProofCharge);
    }
  }, [
    props.price,
    props.quantity,
    props.hasPhotos,
    props.hasArt,
    props.selectedProofOption
  ]);

  return (
    <div className="quantity">
      <div className="quantity__totals">
        <div className="quantity__total">
          <h3>Quantity</h3>
          <div className="quantity__number">{props.quantity}</div>
        </div>

        <div className="quantity__price">
          <h3>Price</h3>
          <div className="quantity__price__container">
            <p className="price">${totalPrice}</p>

            <div className="quantity__proof">
              {digitalProofCharge === 15 && <div>+ $15 digital proof</div>}

              {digitalProofCharge === 50 && <div>+ $50 custom art</div>}

              {props.isRepousse && <div>+ $25 foil embossed plate</div>}

              {props.largePlate && <div>+ $10 excess plate</div>}
            </div>
          </div>
        </div>
      </div>

      <DropdownContainer
        quantity={props.quantity}
        pricebreaks={props.pricebreaks}
        totalPrice={totalPrice}
        initialPrice={props.initialPrice}
        price={props.price}
        totalSavings={props.totalSavings}
        minimumQuantity={props.minimumQuantity}
        dropdownActive={dropdownActive}
        quantityIncrement={props.quantityIncrement}
        handleUpdateQuantity={props.handleUpdateQuantity}
        handleUpdateSavings={props.handleUpdateSavings}
        handleCloseDropdown={handleCloseDropdown}
        handleOpenDropdown={handleOpenDropdown}
      />
    </div>
  );
};

export default SelectQuantity;
